import { render, staticRenderFns } from "./global-answer-states.vue?vue&type=template&id=2d44a024&scoped=true&"
import script from "./global-answer-states.vue?vue&type=script&lang=js&"
export * from "./global-answer-states.vue?vue&type=script&lang=js&"
import style0 from "./global-answer-states.vue?vue&type=style&index=0&id=2d44a024&lang=scss&scoped=true&"
import style1 from "./global-answer-states.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44a024",
  null
  
)

export default component.exports